import playController from './PlayController';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';

const animator = {
    element: undefined,
    timer: undefined,

    //opacity fade-in-and-out animation
    TIMES: 3,
    opacity: 1,
    sign: -1,
    cycles: 0,

    //color animation
    TIMES_COLOR: 4,
    initialBackground: undefined,
    counter: 0,
    items: undefined,

    startAnimation(id) {
        if (playController.isAudioEditorAvailable())
            return;

        this.startColorAnimation(id);
    },

    //color animation
    startColorAnimation(id) {
        if (this.timer)
            clearInterval(this.timer);

        this.timer = setInterval(this.changeColor.bind(this), 300);
        this.element = document.getElementById(id);

        if (id == 'slideSoundEffect')
            this.items = document.getElementsByClassName('slideSoundEffectAnimation');
        else
        if (id == 'slideSound')
            this.items = document.getElementsByClassName('slideSoundAnimation');
        else
            this.items = document.getElementsByClassName('colorAnimation');

        this.counter = 0;
    },
    changeColor() {
        this.counter = this.counter + 1;

        var value = this.counter % 2;
        value = parseFloat(value.toFixed(2));

        if (!this.element)
            return;

        var i;
        if (value != 0) {
            this.element.style.background = 'black';

            if (this.items && this.items.length > 0) {
                for (i = 0; i < this.items.length; i++) {
                    this.items[i].style.color = 'white';
                }
            }
        }
        else {
            this.element.style.background = 'white';

            if (this.items && this.items.length > 0) {
                for (i = 0; i < this.items.length; i++) {
                    this.items[i].style.color = 'black';
                }
            }
        }

        if (this.counter >= this.TIMES_COLOR && this.timer) {
            clearInterval(this.timer);

            this.element.style.background = 'white';

            if (this.items && this.items.length > 0) {
                for (i = 0; i < this.items.length; i++) {
                    this.items[i].style.color = 'black';
                }
            }
        }
    },

    // opacity animation
    startOpacityAnimation(item) {
        audioEditorUtils.animationId = undefined;

        if (this.timer)
            clearInterval(this.timer);

        if (this.element)
            this.element.style.opacity = 1;

        this.timer = setInterval(this.changeAlpha.bind(this), 20);
        this.element = item;
        this.opacity = 1;
        this.cycles = 0;
        this.sign = -1;
    },
    changeAlpha() {
        var opacity = this.opacity + this.sign / 10;
        opacity = parseFloat(opacity.toFixed(2));

        if (opacity == 0) {
            this.sign = 1;
            this.cycles = this.cycles + 1;
        } else
        if (opacity == 1)
            this.sign = -1;

        this.element.style.opacity = opacity;
        this.opacity = opacity;

        if (this.cycles == this.TIMES && opacity == 1 && this.timer) {
            clearInterval(this.timer);
        }
    }
};

export default animator;



/** WEBPACK FOOTER **
 ** ./src/components/utils/Animator.js
 **/